import React from 'react';
import TextLink, { TextLinkProps } from '../../Typography/TextLink/TextLink';

export type BreadcrumbItemProps = {
  /** Label for breadcrumb item */
  label: string;
  /** Breadcrumb item callback */
  onClick: () => void;
  /** Breadcrumb item unique ID */
  value: string;
  /** Renders truncated breadcrumb list as span's children for easier css positioning and accessibility  */
  truncateToggle?: boolean;
} & Omit<TextLinkProps, 'size' | 'color' | 'to'>;
// Alias for backwards compatibility
export type BreadcrumbItemShape = BreadcrumbItemProps;

const BreadcrumbItem: React.FunctionComponent<BreadcrumbItemProps> = ({
  label,
  children,
  truncateToggle,
  ...props
}) => {
  return (
    <>
      {truncateToggle ? (
        <>
          <TextLink size="sm" {...props} color={'gray800'}>
            {label}
          </TextLink>
          {children}
        </>
      ) : (
        <TextLink size="sm" {...props} color={'gray800'}>
          {label}
        </TextLink>
      )}
    </>
  );
};

export default BreadcrumbItem;
